
import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

import RegisterMunchenForm from "./RegisterMunchen/RegisterMunchenApp";
import RegistroDoctoresForm from "./RegistroDoctores/RegistroDoctoresApp";
import PrecitaReferentesForm from "./PrecitaReferentes/PrecitaReferentesApp";
import PrecitaPacientesForm from "./PrecitaPacientes/PrecitaPacientesApp";

require('dotenv').config();

const App = () => (
    <Router basename="/register">
        <Switch>
            <Route exact path="/" />
            <Route exact path="/patiententermin" component={PrecitaPacientesForm} />
            <Route exact path="/patientpreappointment" component={PrecitaPacientesForm} />
            <Route exact path="/precitapacientes" component={PrecitaPacientesForm} />
            <Route path="/precitareferentes" component={PrecitaReferentesForm} />
            <Route path="/doctor" component={RegisterMunchenForm} />
            <Route path="/doktor" component={RegisterMunchenForm} />
            <Route path="/doctores" component={RegistroDoctoresForm} />
        </Switch>
    </Router>
);

export default App;
// You can think of these components as "pages"
// in your app.

